<app-chart [config]="config" [id]="canvasId" [label]="label" [data]="yearSumArray" ></app-chart>